
























import Vue from 'vue'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'

interface ComponentData {
  dateFormatted: string
  date: string | null
  dateRules: any[]
  menu: boolean
}

export default Vue.extend({
  name: 'AdditionalFieldsDatePicker',

  props: {
    item: {
      type: Object as () => AdditionalField
    }
  },

  data (): ComponentData {
    return {
      dateFormatted: '',
      date: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value && value.length >= 1 ? pattern.test(value) || 'Falsche Datum.' : true
        },

        (value: string) => {
          return value && value.length !== 10 ? 'Falsche Datum.' : true
        }
      ],
      menu: false
    }
  },

  computed: {
    selectedLocale(): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  watch: {
    dateFormatted (newVal: string): void {
      if(newVal.length > 0) {
        this.date = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
        const form: any = this.$refs['form']
        if(newVal.length === 10 && form.validate()) {
          this.onValueChange(newVal)
        }
      } else {
        this.onValueChange('')
      }
    }
  },

  methods: {
    onDateChange (date: string): void {
      if(date.length > 0) {
        this.dateFormatted = moment(date).format('DD.MM.YYYY')
        this.onValueChange(this.dateFormatted)
      } else {
        this.dateFormatted = ''
        this.onValueChange(this.dateFormatted)
      }
    },

    onValueChange (value: string): void {
      const payload: AdditionalFieldItem = {
        parentType: this.item.type,
        componentId: this.item.componentId,
        value: value,
        designation: '',
        id: 0,
        groupId: this.item.groupId,
        project: this.item.project
      }
      this.$emit('onValueChange', payload)
    },

    onFocus (): void {
      setTimeout(() => {
        if(!this.menu) {
          this.menu = true
        }
      }, 100)
    },

    onBlur (): void {
      setTimeout(() => {
        if(this.menu) {
          this.menu = false
        }
      }, 100)
    },
  },

  created () {
    if(this.item && this.item.value) {
      this.dateFormatted = this.item.value
      this.date = moment(this.item.value, 'DD.MM.YYYY').format('YYYY-MM-DD')
    }
  }

})
